import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'

import { Checkbox, CHECKBOX_SIZE, CHECKBOX_TYPE } from '../../../../Checkbox'
import { FormFieldsContainer } from '../../../../Form'
import {
  FormikField,
  getFormikCheckboxFieldValueProps,
} from '../../../../Formik'
import Text from '../../../../Text'
import { BUILDING_GROUP_ACTION_REMOVE_GROUP_FIELD_NAME_REMOVE_MANAGERS } from '../BuildingGroupsRemoveActionModal.constants'

function FormFields({
  confirmationTextKey = 'BuildingGroup.RemoveGroupConfirmationTextKey',
}) {
  const { t } = useTranslation()

  return (
    <FormFieldsContainer>
      <Text>{t(confirmationTextKey)} </Text>
      <FormikField
        Component={Checkbox}
        Field={Fragment}
        getValueProps={getFormikCheckboxFieldValueProps}
        label={t('BuildingGroup.UpdateManagersFieldLabelKey')}
        name={BUILDING_GROUP_ACTION_REMOVE_GROUP_FIELD_NAME_REMOVE_MANAGERS}
        size={CHECKBOX_SIZE.small}
        type={CHECKBOX_TYPE.action}
      />
    </FormFieldsContainer>
  )
}

export default FormFields
